<template>
	<div>
		<el-dialog title="对公转账" :show-close="false" @before-close="handleClose" destroy-on-close :visible="payModal" width="35%">
			<div style="overflow: hidden">
				<div class="tab-pane-left">
					<div class="pay-title">请使用以下信息进行对公转账</div>
					<div>单位名称：北京品读文化发展有限公司</div>
					<div>单位银行账号：110060907018010020725</div>
					<div>开户行：交通银行北京胜古园支行</div>
					<div>开户银行行号：301100000494</div>
					<div>
						订单号：<b>{{ orderNum }}</b>
					</div>
					<div>
						<input ref="updateImgInput" accept="image/png, image/jpeg" style="display: none" type="file" @change="updateChange" />
						<el-link :underline="false" class="modify-img;" style="display: block" type="primary" @click="updateImg">上传转账凭证</el-link>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getFilesPreview, postFilesUpload } from '@/api/file/file';
import TMessage from '@/utils/TMessage';
import User from '@/utils/User';
export default {
	name: 'OfflineTransfer',
	props: {
		orderNum: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			payModal: false
		};
	},

	methods: {
		//出发input标签事件
		updateImg() {
			this.$refs.updateImgInput.click();
		},

		//选择后的事件
		async updateChange(event) {
			let Max_Size = 1024 * 100; //100KB
			let file = event.target.files[0];
			if (file.type === 'image/jpeg' || file.type === 'image/png') {
				if (file.size * 0.0009766 > Max_Size) {
					TMessage.warning('转账凭证大小不能大于100MB，请重新上传');
					return;
				} else {
					let res = await postFilesUpload(file);
					if (res.code == 200) {
						let url = res.data;
						this.form.avatar = url;
						this.getFilesInfo(url);
						TMessage.success('转账凭证上传成功');
					}
				}
			} else {
				TMessage.warning('转账凭证只能上传图片类型，请重新上传');
			}
		},

		// 获取文件详情
		async getFilesInfo(url) {
			try {
				const prefix = '/third/files/info/';
				const key = url.replace(prefix, '');
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const imageUrlData = URL.createObjectURL(blob);
				this.$set(this.form, 'avatarUrl', imageUrlData);
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},

		//关闭支付弹框
		handleClose() {
			this.payModal = false;
		}
	}
};
</script>

<style lang="less" scoped>
.money {
	font-size: 26px;
	font-weight: 700;
	color: #f60;
}

.qrcode {
	display: inline-block;
	margin-bottom: 10px;
	overflow: hidden;
	width: 198px;
	height: 198px;
}

.pay-title {
	color: #4f8dfe;
	text-align: center;
	line-height: 30px;
	font-size: 16px;
}

.tab-pane-left {
	width: 50%;
	float: left;
}

.tab-pane-right {
	width: 49%;
	float: left;
	height: 100%;
}

.tab-pane-right-img {
	width: 85%;
	height: 100%;
	margin: 0 auto;
}

.tab-pane-right-img img {
	height: 100%;
	width: 100%;
}

/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>